module.exports = __webpack_public_path__ + "components/flag/static/square/ht-a1e224529210bbc8c3f40a59f2ea736f.svg";